<template>
  <div class="real_page" id="trendView">
    <el-dialog
      :close-on-click-modal="false"
      title="趋势查看"
      :visible.sync="trendDialog"
      class="large-dialog"
      ref="trend_dialog"
      v-dialogDrag
      :show-close="false"
      v-show="!smallDialog"
      :fullscreen="isFullScreen"
    >
      <div slot="title" class="relative">
        <span class="font-bold">趋势查看</span>
        <span
          class="el-dialog__close el-icon el-icon-close absolute cursor-pointer icon_hover"
          style="top: 2px; right: 0"
          @click="closeDialog"
        ></span>
        <span
          class="absolute iconfont icon-fullscreen cursor-pointer icon_hover"
          style="top: 2px; right: 25px"
          @click="toggleScreen"
        ></span>
        <span
          class="absolute el-icon-minus cursor-pointer icon_hover"
          style="top: 2px; right: 50px"
          @click="toggleSmallDialog('shrink')"
        ></span>
      </div>
      <div style="border-bottom: 1px solid #d9d9d9" class="flex items-center text-12px pb-10px">
        <el-tooltip :content="'打印'">
          <i
            class="iconfont icon-bg-jpg mr-5px text-18px cursor-pointer ml-10px"
            @click="doPrint"
          ></i>
        </el-tooltip>
        <el-tooltip :content="'导出'">
          <i
            class="iconfont icon-bg-excel mr-5px text-18px cursor-pointer ml-5px"
            @click="exportToExcel"
          ></i>
        </el-tooltip>
        <el-autocomplete
          v-model="search.code"
          :fetch-suggestions="querySearch"
          clearable
          placeholder="添加测点"
          @select="handleSelect"
          style="width: 200px"
          value-key="name"
          popper-class="w-250"
          :loading="true"
        >
          <template slot="suffix">
            <span
              class="el-input__suffix-inner"
              v-if="search.code"
              @click="clearKKs($event)"
              style="opacity: 0"
            >
              <i class="el-input__icon el-icon-circle-close el-input__clear"></i>
            </span>
          </template>
        </el-autocomplete>
        <el-switch
          v-model="search.status"
          active-color="#1890ff"
          active-text="实时"
          :active-value="0"
          inactive-color="#b2b2b2"
          inactive-text="历史"
          :inactive-value="1"
          :width="55"
          class="ml-5px mr-5px"
          @change="switchChange"
        ></el-switch>
        <!-- <el-input
          placeholder="颗粒度"
          v-model="search.interval"
          style="width:100px;"
          type="number"
          min="1"
        ></el-input>
        <el-select v-model="search.date" slot="append" style="width:85px;">
          <el-option
            v-for="(item, index) in dateData"
            :key="`${item}${index}`"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
        <span class="ml-15px mr-5px">快速选取</span>
        <el-select v-model="search.timeSpan" style="width: 110px" @change="timeSpanChange">
          <el-option
            v-for="(item, index) in spanData"
            :key="`${item}${index}`"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="ml-15px mr-5px"
          >时间选择
          <date-time
            :model.sync="search.time"
            model-name="search.time"
            value-format="YYYY-MM-DD HH:mm:ss"
            input-width="200px"
            :clearable="true"
            :disabledAfterToday="true"
            :key="updateTime"
          ></date-time>
        </span>
        <el-button
          type="primary"
          icon="iconfont icon-search"
          size="small"
          class="ml-10px"
          @click="searchTrend"
          >搜索</el-button
        >
      </div>
      <!-- <v-chart
        style="height: calc(100% - 246px);width:100%;"
        ref="echart"
        :options="echartOption"
        :key="chartKey"
        theme="macarons"
        v-if="trendDialog"
      ></v-chart> -->
      <div
        style="height: calc(100% - 247px); width: 100%"
        id="chartLine"
        v-if="trendDialog"
        :key="chartKey"
        v-loading="lineLoading"
      ></div>
      <div style="height: 200px" class="trend_table">
        <el-table
          :data="trendTableData"
          height="100%"
          class="w-full"
          ref="trendTable"
          @select="tableSelectChange"
          border
          stripe
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column label="测点编码" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-popover
                placement="top"
                width="266"
                v-model="scope.row.visible"
                @show="showColorBar(scope.row)"
              >
                <el-row :gutter="20">
                  <el-col :span="20">
                    <el-select v-model="lineWidth" style="width: 100%">
                      <el-option
                        v-for="item in widthOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="20">
                    <el-select v-model="lineStyle" style="width: 100%">
                      <el-option
                        v-for="item in lineStyleOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <ul class="color_box">
                  <li
                    v-for="(item, index) in Array(16)"
                    :key="`${index}color`"
                    :class="{ active: colorIndex === index }"
                    @click="colorIndex = index"
                  >
                    <div
                      class="h-full w-full"
                      :style="{ 'background-color': colorBar[index] }"
                    ></div>
                  </li>
                </ul>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.visible = false"
                    >取消</el-button
                  >
                  <el-button type="primary" size="mini" @click="setStyle(scope.row)"
                    >确定</el-button
                  >
                </div>
                <div slot="reference" class="relative">
                  <div
                    style="height: 12px; width: 12px; left: 0; top: 6px"
                    :style="{ 'background-color': scope.row.color }"
                    class="absolute"
                  ></div>
                  <span class="ml-15px">{{ scope.row.code }}</span>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column label="中文名称" prop="name" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="当前值"
            prop="currentValue"
            show-overflow-tooltip
            width="80"
          ></el-table-column>
          <el-table-column
            label="最大值"
            prop="maxValue"
            show-overflow-tooltip
            width="80"
          ></el-table-column>
          <el-table-column
            label="最小值"
            prop="minValue"
            show-overflow-tooltip
            width="80"
          ></el-table-column>
          <el-table-column
            label="平均值"
            prop="avg"
            show-overflow-tooltip
            width="80"
          ></el-table-column>
          <el-table-column label="Y轴自定义" width="250">
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.minSection"
                @change="saveYAxis(scope.row)"
                class="w-100px"
                size="mini"
              ></el-input-number
              >~
              <el-input-number
                v-model="scope.row.maxSection"
                class="w-100px"
                size="mini"
                @change="saveYAxis(scope.row)"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="" width="80">
            <template slot-scope="scope">
              <el-button size="mini" @click="deletePoint(scope.row)" class="!leading-23px"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <div id="lock-win" v-if="smallDialog">
      <h4>
        已添加的测点
        <i class="iconfont icon-fullscreen icon mr-20px" @click="toggleSmallDialog('magnify')"></i>
        <i class="icon el-icon-circle-close-outline" @click.stop="closeLockWin"></i>
      </h4>
      <ul class="tagId-list">
        <li v-for="(item, index) in tagIdTbData" :key="index">
          {{ item }}
          <i class="icon el-icon-circle-close-outline" @click.stop="deleteTagId(item)"></i>
        </li>
      </ul>
    </div>
    <div
      style="position: absolute; top: -9999999px; left: -999999px; width: 600px; height: 400px"
      id="unshowEcharts"
    ></div>
  </div>
</template>

<script type="text/babel">
import alarmService from '@/services/AlarmManagement'
import { _debounce } from '@/assets/js/common/common'
import measuringPointService from '@/services/MeasuringPoint'
import DateTime from './dateTime'
import realTimeService from '@/services/RealTimeWatch'
import fnMixin from '@/assets/js/fnMixins'

export default {
  components: {
    DateTime,
  },
  props: ['standardId'],
  data() {
    return {
      isFullScreen: false,
      isRealStatus: true,
      updateTime: 123213,
      trendDialog: false,
      smallDialog: false,
      tagIdTbData: [],
      yAxisValue: [],
      echartOption: {
        animation: false,
        color: [
          '#3f51b5',
          '#e51c23',
          '#009688',
          '#259b24',
          '#ff9800',
          '#8129bd',
          '#b5c334',
          '#fcce10',
          '#e87c25',
          '#27727b',
        ],
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            let formatStr = `${moment(params[0].data[0]).format('YYYY-MM-DD HH:mm:ss')}<br/>`
            _.forEach(params, (item) => {
              formatStr = `${formatStr}${item.marker}${item.seriesName}: ${item.data[1]}<br/>`
            })
            return formatStr
          },
          axisPointer: {
            type: 'cross',
            label: {
              show: true,
              backgroundColor: 'rgba(80, 87, 101, 0.4)',
            },
          },
          show: true,
        },
        grid: {
          left: 35,
          right: 35,
          top: 30,
          bottom: '3%',
          containLabel: true,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
        ],
        xAxis: {
          type: 'time',
          // splitNumber: 6,
          interval: '',
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: '#31B6F9',
            },
          },
        },
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [],
      },
      chartKey: 1546,
      search: {
        status: 0,
        interval: 1,
        date: 0,
        timeSpan: 0,
        time: [],
        code: '',
      },
      trendTableData: [],
      dateData: [
        {
          label: '秒',
          value: 0,
        },
        {
          label: '分钟',
          value: 1,
        },
        {
          label: '小时',
          value: 2,
        },
        {
          label: '天',
          value: 3,
        },
      ],
      colorBar: [
        '#FF8000',
        '#FF0000',
        '#00FF00',
        '#0000FF',
        '#00FF80',
        '#00FFFF',
        '#FF00FF',
        '#9ACD32',
        '#009900',
        '#008080',
        '#D87A80',
        '#FFB980',
        '#FC6335',
        '#8A2BE2',
        '#C71585',
        '#0080FF',
      ],
      lineStyle: 'solid',
      lineStyleOptions: [
        {
          label: '实线',
          value: 'solid',
        },
        {
          label: '虚线',
          value: 'dashed',
        },
      ],
      lineWidth: '1',
      widthOptions: [
        {
          label: '1px',
          value: '1',
        },
        {
          label: '2px',
          value: '2',
        },
        {
          label: '3px',
          value: '3',
        },
        {
          label: '4px',
          value: '4',
        },
      ],
      colorIndex: 0,
      condition: null,
      tableCondition: null,
      chartTimer: true,
      tableTimer: true,
      selected: [],
      chartLine: null,
      spanData: [
        {
          label: '10分钟',
          value: 0,
        },
        {
          label: '30分钟',
          value: 1,
        },
        {
          label: '1小时',
          value: 2,
        },
        {
          label: '4小时',
          value: 3,
        },
        {
          label: '8小时',
          value: 4,
        },
        {
          label: '1天',
          value: 5,
        },
      ],
      restoreCondition: {},
      lineLoading: false,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters['Sites/currentProject'] || {}
    },
  },
  watch: {
    trendDialog(val) {
      if (val) {
        this.smallDialog = false
        return
      }
      this.trendTableData = []
    },
    trendTableData(val) {
      this.tableTimer = !!val.length
    },
  },
  methods: {
    // 全屏/缩放 查看趋势窗口
    toggleScreen() {
      this.isFullScreen = !this.isFullScreen
      // this.chartKey += 1
      this.$nextTick(() => {
        if (this.chartLine) {
          this.chartLine.resize()
        }
      })
    },
    // 最小化/放大 查询趋势窗口
    toggleSmallDialog(type) {
      if (type === 'shrink') {
        this.tagIdTbData = _.map(this.trendTableData, (o) => {
          return o.code
        })
        document.getElementsByClassName('v-modal')[0].style.display = 'none'
        this.smallDialog = true
        this.chartTimer = false
        this.tableTimer = false
      } else {
        document.getElementsByClassName('v-modal')[0].style.display = 'unset'
        this.smallDialog = false
        this.chartTimer = true
        this.tableTimer = true
        this.tableSelectChange(this.selected)
      }
    },
    // 打印
    doPrint() {
      if (this.trendTableData.length === 0) {
        this.$message.warning('请先添加测点!')
        return
      }
      const newWindow = window.open('', '', 'height=768,width=1200,top=200,left=300')
      newWindow.document.title = '趋势查看'
      // 获取图路径
      const echart = this.$echarts.init(document.getElementById('unshowEcharts'))
      echart.clear()
      echart.setOption(this.echartOption)
      const oImgPath = echart.getDataURL({
        type: 'png',
        pixelRadio: 5,
        backgroundColor: '#fff',
      })
      const headHtml = `<div style="margin-bottom:20px;"><span style="margin-right:10px;">状态：${
        this.search.status === 0 ? '实时' : '历史'
      }</span><span style="margin-right:10px;">时间选择：${
        this.search.time.length > 0 ? this.search.time[0] : '开始时间'
      }至${
        this.search.time.length > 0 ? this.search.time[1] : '结束时间'
      }</span></div><div style='border: 1px solid black;'><img width='100%' height='auto' src='${oImgPath}'></div>`
      newWindow.document.write(headHtml)
      // newWindow.document.write(prnhtml)
      const thData = [
        '测点编码',
        '中文名称',
        '单位',
        '实时值',
        '最大值',
        '最小值',
        '平均值',
        'Y轴自定义',
      ]
      const trData = _.map(this.trendTableData, (o) => {
        return [
          o.code,
          o.name,
          o.unit,
          o.currentValue,
          o.maxValue,
          o.minValue,
          o.avg,
          `${o.minSection}~${o.maxSection}`,
        ]
      })
      const oTable = document.createElement('table')
      oTable.style.marginTop = '20px'
      const oThead = document.createElement('tr')
      let th = ''
      _.forEach(thData, (o) => {
        th += `<th>${o}</th>`
      })
      oThead.innerHTML = th
      oTable.appendChild(oThead)
      _.forEach(trData, (o) => {
        const oTr = document.createElement('tr')
        let tr = ''
        _.forEach(o, (item, index) => {
          if (index === 0) {
            tr += `<td><div style="border:6px solid ${this.echartOption.color[index]};height:0px;width:0px;display:inline-block;"></div><span>${item}</span></td>`
          } else {
            tr += `<td>${item}</td>`
          }
        })
        oTr.innerHTML = tr
        oTable.appendChild(oTr)
      })
      newWindow.document.body.appendChild(oTable)
      this.setPrintSrtyle(newWindow)
      setTimeout(() => {
        newWindow.print()
        newWindow.close()
      }, 30)
    },
    // 设置打印样式
    setPrintSrtyle(newWindow) {
      const oTable = newWindow.document.querySelector('table')
      oTable.border = 1
      oTable.width = '100%'
      oTable.style.textAlign = 'center'
      oTable.style.borderCollapse = 'collapse'
      oTable.marginTop = '10px'
    },
    // 生成表格
    async exportToExcel() {
      if (this.trendTableData.length === 0) {
        this.$message.warning('请先添加测点!')
        return
      }
      const echart = this.$echarts.init(document.getElementById('unshowEcharts'))
      echart.clear()
      echart.setOption(this.echartOption)
      // const path = echart.getDataURL('png')
      const tags = _.map(this.trendTableData, (o) => {
        return o.pointId
      })
      const res = await realTimeService.exportExcel({
        // type: 0,
        // flowchart: path,
        standardId: this.standardId,
        pointIds: tags,
        startTime: (moment(this.condition.startTime).valueOf() / 1000).toFixed(0),
        endTime: (moment(this.condition.endTime).valueOf() / 1000).toFixed(0),
        // data_store_type: 0,
        // app_id: 1, // 暂定
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
      })
      if (res) {
        const time = fnMixin.methods.getNowTime()
        fnMixin.methods.downLoadExcel(`趋势查看${time}`, res)
      }
    },
    // 查询测点
    async getPoint(word, tagId) {
      const currentTime = (moment().valueOf() / 1000).toFixed()
      const res = await measuringPointService.getList({
        startTime: currentTime,
        endtime: currentTime,
        SearchText: word || '',
        SkipCount: 1,
        MaxResultCount: word === '' ? 20 : 999,
        StandardId: this.standardId,
        PointIds: tagId,
      })
      if (res.code === 0 && !_.isNil(res.data)) {
        return res.data
      }
      return []
    },
    // 获取输入建议
    async querySearch(word, cb) {
      // debugger
      const result = await this.getPoint(word)
      cb(result)
    },
    // 选择输入建议
    handleSelect(item) {
      const haveIt = _.findIndex(this.trendTableData, { pointId: item.pointId })
      if (haveIt > -1) {
        return this.$message.warning('请勿添加重复测点!')
      }
      let colorList = _.cloneDeep(this.colorBar)
      _.forEach(this.trendTableData, (o) => {
        colorList = _.difference(colorList, [o.color])
      })
      this.search.code = ''
      const params = {
        visible: false,
        color: colorList[0],
        idx: this.trendTableData.length
          ? this.trendTableData[this.trendTableData.length - 1].idx + 1
          : 0,
        minValue: '',
        maxValue: '',
        currentValue: '',
        avg: '',
        minSection: '',
        maxSection: '',
        lineStyle: 'solid',
        lineWidth: '1',
        ...item,
        id: item.id,
        pointId: item.pointId,
      }
      this.trendTableData.push(params)
      if (this.selected.length < 10) {
        this.selected.push(params)
        this.tableSelectChange(this.selected)
        this.$refs.trendTable.toggleRowSelection(params, true)
      }
      // this.searchTrend()
      return true
    },
    // 添加测点
    async addPoint(tagId) {
      const result = await this.getPoint('', tagId)
      if (result.length === 0) {
        this.$message.warning('查询不到该测点数据,添加失败!')
        return
      }
      this.handleSelect(result[0])
    },
    // 清除测点编码
    clearKKs(e) {
      e.stopPropagation()
      this.code = ''
    },
    // 显示颜色板
    showColorBar(row) {
      this.lineStyle = row.lineStyle
      this.lineWidth = row.lineWidth
      _.forEach(this.colorBar, (o, i) => {
        if (o === row.color) {
          this.colorIndex = i
        }
      })
    },
    // 确定测点设置
    setStyle(row) {
      const currentColor = this.colorBar[this.colorIndex]
      const index = _.findIndex(this.echartOption.series, { name: row.name })
      if (index > -1) {
        this.echartOption.series[index].lineStyle = {
          width: this.lineWidth,
          type: this.lineStyle,
        }
        this.echartOption.color[index] = currentColor
      }
      this.chartLine.setOption({
        series: this.echartOption.series,
        color: this.echartOption.color,
      })
      this.trendTableData[row.idx].color = currentColor
      this.trendTableData[row.idx].lineWidth = this.lineWidth
      this.trendTableData[row.idx].lineStyle = this.lineStyle
      this.trendTableData[row.idx].visible = false
    },
    // 删除测点
    deletePoint(data) {
      this.trendTableData = _.differenceWith(this.trendTableData, [data], _.isEqual)
      const row = _.find(this.selected, { name: data.name })
      if (row) {
        this.selected = _.differenceWith(this.selected, [data], _.isEqual)
        this.tableSelectChange(this.selected)
        _.forEach(this.selected, (o) => {
          this.$nextTick(() => {
            this.$refs.trendTable.toggleRowSelection(o, true)
          })
        })
        this.echartOption.series = _.differenceWith(
          this.echartOption.series,
          [_.find(this.echartOption.series, { name: data.name })],
          _.isEqual
        )
        this.chartLine.setOption({
          series: this.echartOption.series,
        })
        // this.chartKey += 1
      }
    },
    // 删除已添加的测点
    deleteTagId(point) {
      this.$confirm('此操作将永久删除该测点, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        document.getElementsByClassName('v-modal')[0].style.display = 'none'
        if (this.tagIdTbData.length === 1) {
          this.$message.warning('至少保留一个测点！')
          return
        }
        const current = _.find(this.trendTableData, { code: point })
        this.trendTableData = _.differenceWith(this.trendTableData, [current], _.isEqual)
        this.tagIdTbData = _.map(this.trendTableData, (o) => {
          return o.code
        })
        this.echartOption.series = _.differenceWith(
          this.echartOption.series,
          [_.find(this.echartOption.series, { name: current.name })],
          _.isEqual
        )
      })
    },
    // 格式化曲线tooltip光标值
    formatterFuns() {
      return (params) => {
        if (params.axisDimension === 'y') {
          // if (params.axisIndex !== this.echartOption.series.length - 1) return ''
          const idx = _.findIndex(this.yAxisValue, { axisIndex: params.axisIndex })
          if (idx > -1) {
            this.yAxisValue[idx] = params
          } else {
            this.yAxisValue.push(params)
          }
          let formatStr = '光标值'
          _.forEach(this.yAxisValue, (o, i) => {
            if (i < this.echartOption.series.length) {
              formatStr = `${formatStr}\n${
                this.echartOption.series[o.axisIndex].name
              }: ${o.value.toFixed(2)}`
            }
          })
          return formatStr
        }
        return moment(params.value).format('YYYY-MM-DD HH:mm:ss')
      }
    },
    formatterXAxis() {
      return (value) => {
        // if (this.search.date === 0) {
        //   return `${moment(value).format('HH:mm:ss')}\n${moment(value).format('YYYY-MM-DD')}`
        // }
        // if (this.search.date === 1) {
        //   return `${moment(value).format('HH:mm')}\n${moment(value).format('YYYY-MM-DD')}`
        // }
        // if (this.search.date === 2) {
        //   return `${moment(value).format('YYYY-MM-DD HH')}`
        // }
        // return `${moment(value).format('YYYY-MM-DD')}`
        return `${moment(value).format('HH:mm:ss')}\n${moment(value).format('YYYY-MM-DD')}`
      }
    },
    closeDialog() {
      this.chartTimer = false
      this.tableTimer = false
      this.yAxisValue = []
      this.trendTableData = this.$options.data().trendTableData
      this.selected = []
      this.search = this.$options.data().search
      this.echartOption = this.$options.data().echartOption
      this.echartOption.tooltip.axisPointer.label.formatter = this.formatterFuns()
      this.echartOption.xAxis.axisLabel.formatter = this.formatterXAxis()
      this.trendDialog = false
    },
    // 关闭最小化的窗口
    closeLockWin() {
      this.smallDialog = false
      this.closeDialog()
    },
    handleTimezone(val) {
      if (_.isArray(val) && val.length) {
        const end = moment(val[1]).unix()
        const start = moment(val[0]).unix()
        if (end - start > 86400) {
          return false
        }
      }
      return true
    },
    // 切换实时历史
    async switchChange(data) {
      if (!this.trendDialog) return
      if (data === 1) {
        this.searchTrend()
      } else {
        if (this.trendTableData.length === 0) {
          this.$message.warning('请先添加测点!')
          return
        }
        this.chartTimer = true
        this.condition = {
          // interval: this.computedInterval(this.search.date) * this.search.interval,
          tagsId: _.map(this.selected, (o) => {
            return o.pointId
          }).join(','),
        }
        if (!this.condition.tagsId) this.chartTimer = false
        this.search.time = []
        this.updateTime += 1
        const ts = this.computedTimeSpan(this.search.timeSpan)
        this.condition.startTime = moment()
          .subtract(ts.value, ts.date)
          .format('YYYY-MM-DD HH:mm:ss')
        this.condition.endTime = moment().format('YYYY-MM-DD HH:mm:ss')
        const lineData = await this.getTrendLine(this.condition)
        this.restoreCondition = {
          status: this.search.status,
          date: this.search.time,
        }
        this.createLine(lineData)
        this.tableCondition = {
          // interval: this.computedInterval(this.search.date) * this.search.interval,
          startTime: this.condition.startTime,
          endTime: this.condition.endTime,
        }
        this.getTableData(this.tableCondition, false)
      }
    },
    timeSpanChange() {
      this.search.time = []
      this.searchTrend()
    },
    // 搜索测点数据/趋势
    async searchTrend() {
      this.echartOption.series = []
      if (this.trendTableData.length === 0) {
        this.chartLine.clear()
        return this.$message.warning('请先添加测点!')
      }
      // if (this.search.date === 0 && this.search.time.length) {
      //   const checked = this.handleTimezone(this.search.time)
      //   if (!checked) {
      //     return this.$message.warning('秒级数据最大选择区间为1天!')
      //   }
      // }
      this.condition = {
        // interval: this.computedInterval(this.search.date) * this.search.interval,
        tagsId: _.map(this.selected, (o) => {
          return o.pointId
        }).join(','),
      }
      if (!this.condition.tagsId) this.chartTimer = false
      this.search.status = 1
      if (!this.search.time.length) {
        const ts = this.computedTimeSpan(this.search.timeSpan)
        this.search.time[0] = moment()
          .subtract(ts.value, ts.date)
          .format('YYYY-MM-DD HH:mm:ss')
        this.search.time[1] = moment().format('YYYY-MM-DD HH:mm:ss')
        this.updateTime += 1
      }
      const [startTime, endTime] = this.search.time
      if (startTime && endTime) {
        if (new Date(startTime).getTime() - new Date(endTime).getTime() > 0) {
          this.$message.error('开始时间不能大于结束时间')
          return false
        }
      }
      this.condition.startTime = startTime
      this.condition.endTime = endTime
      this.chartTimer = false
      const lineData = await this.getTrendLine(this.condition)
      this.restoreCondition = {
        status: this.search.status,
        date: this.search.time,
      }
      this.createLine(lineData)
      this.tableCondition = {
        // interval: this.computedInterval(this.search.date) * this.search.interval,
        startTime: this.condition.startTime,
        endTime: this.condition.endTime,
      }
      this.getTableData(this.tableCondition, false)
      return true
    },
    async zoomEvent(params) {
      let startTime = this.condition.startTime
      let endTime = this.condition.endTime
      if (this.search.status === 0) {
        this.search.status = 1
        const ts = this.computedTimeSpan(this.search.timeSpan)
        startTime = moment(startTime)
          .subtract(ts.value, ts.date)
          .format('YYYY-MM-DD HH:mm:ss')
      } else {
        startTime = this.search.time[0]
        endTime = this.search.time[1]
      }
      this.search.time = []
      if (params.batch.length === 1) {
        const interval = (moment(endTime).valueOf() - moment(startTime).valueOf()) / 4
        const xMin = moment(startTime).valueOf() + interval * (params.batch[0].start / 100)
        const xMax = moment(endTime).valueOf() - interval * (1 - params.batch[0].end / 100)
        this.search.time = [
          moment(xMin).format('YYYY-MM-DD HH:mm:ss'),
          moment(xMax).format('YYYY-MM-DD HH:mm:ss'),
        ]
      } else {
        // this.search.time = [
        //   moment(params.batch[0].startValue).format('YYYY-MM-DD HH:mm:ss'),
        //   moment(params.batch[0].endValue).format('YYYY-MM-DD HH:mm:ss'),
        // ]
        this.search.time = [
          moment(startTime).format('YYYY-MM-DD HH:mm:ss'),
          moment(endTime).format('YYYY-MM-DD HH:mm:ss'),
        ]
      }
      this.condition = {
        // interval: this.computedInterval(this.search.date) * this.search.interval,
        tagsId: _.map(this.selected, (o) => {
          return o.pointId
        }),
        startTime: this.search.time[0],
        endTime: this.search.time[1],
      }
      this.chartTimer = false
      this.tableTimer = false
      const zoonLineData = await this.getTrendLine(this.condition)
      this.createLine(zoonLineData)
      this.getTableData(this.condition, false)
    },
    // 生成曲线
    createLine(lineData) {
      this.echartOption.toolbox = {
        show: true,
        feature: {
          dataZoom: {
            show: true,
            icon: {
              // zoom: 'image://images/refresh.png',
              back: 'image://images/null.png',
            },
          },
          myTool1: {
            show: true,
            title: '复原',
            icon: 'image://images/reset.svg',
            onclick: () => {
              this.search.status = this.restoreCondition.status
              this.search.time = this.restoreCondition.date
              this.switchChange(this.search.status)
            },
          },
        },
        iconStyle: {
          emphasis: {
            textPadding: 15,
          },
        },
      }
      this.lineLoading = true
      this.$echarts.init(document.getElementById('chartLine'), 'macarons').dispose()
      this.chartLine = this.$echarts.init(document.getElementById('chartLine'), 'macarons')
      this.chartLine.clear()
      this.chartLine.on('datazoom', this.zoomEvent)
      if (lineData.length) {
        this.echartOption.yAxis = []
      } else {
        this.echartOption.yAxis = [
          {
            type: 'value',
          },
        ]
      }
      this.echartOption.series = []
      _.forEach(lineData, (o, i) => {
        if (o.pointValues.length) {
          const data = _.map(o.pointValues, (u) => {
            return [u.timeValue * 1000, u.value]
          })
          const index = _.findIndex(this.trendTableData, { pointId: o.pointId })
          const point = this.trendTableData[index]
          this.echartOption.series.push({
            name: point.name,
            pointId: o.pointId,
            type: 'line',
            data,
            lineStyle: {
              width: Number(point.lineWidth),
              type: point.lineStyle,
            },
            yAxisIndex: i,
          })
          this.echartOption.color[i] = point.color
          this.echartOption.yAxis.push({
            min: point.minSection !== '' ? Number(point.minSection) : o.min * 0.95,
            max: point.maxSection !== '' ? Number(point.maxSection) : o.max * 1.05,
            type: 'value',
            show: i === 0,
            position: 'left',
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          })
        }
      })
      this.setXAxisInterval()
      this.lineLoading = false
      this.$nextTick(() => {
        this.chartLine.setOption(this.echartOption)
      })
      if (this.search.time.length === 0) {
        this.updateLine()
      }
    },
    setXAxisInterval() {
      let maxVal = 0
      let minVal = 0
      _.forEach(this.echartOption.series, (item) => {
        if (minVal === 0 || (item.data.length && item.data[0][0] < minVal)) {
          minVal = item.data[0][0]
        }
        if (item.data.length && item.data[item.data.length - 1][0] > maxVal) {
          maxVal = item.data[item.data.length - 1][0]
        }
      })
      this.echartOption.xAxis.interval = (maxVal - minVal) / 4
    },
    // 获取曲线数据
    async getTrendLine(condition) {
      const res = await alarmService.getTrendLine({
        // interval: condition.interval,
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
        pointIds: condition.tagsId.split(','),
        startTime: (moment(condition.startTime).valueOf() / 1000).toFixed(0),
        endTime: (moment(condition.endTime).valueOf() / 1000).toFixed(0),
        // StandardId: this.standardId,
        // pagesize: 10000000,
        dataStoreType: 0,
        // app_id: 1, // 暂定
      })
      if (res && res.code === 0 && !_.isNil(res.data)) {
        return res.data
      }
      return []
    },
    // 获取表格数据（todo）
    async getTableData(condition, isUpdate) {
      const res = await realTimeService.getTrendData({
        // interval: condition.interval,
        interval: 1,
        pointIds: _.map(this.trendTableData, (o) => {
          return o.pointId
        }),
        startTime: (moment(condition.startTime).valueOf() / 1000).toFixed(0),
        endTime: (moment(condition.endTime).valueOf() / 1000).toFixed(0),
        dataStoreType: 0,
        standardId: this.standardId,
        // app_id: 1, // 暂定
        // factory_id: this.currentProject.factoryId,
        // group_id: this.currentProject.groupId,
      })
      if (res && res.code === 0 && !_.isNil(res.data)) {
        _.forEach(this.trendTableData, (o) => {
          const data = _.find(res.data, { pointId: o.pointId })
          if (data) {
            o.currentValue = data.value
            o.maxValue = data.maxValue
            o.minValue = data.minValue
            o.avg = data.avgValue
            const line = _.find(this.echartOption.series, { pointId: o.pointId })
            const min = data.minValue
              ? _.round(data.minValue * (data.minValue > 0 ? 0.95 : 1.05), 2)
              : ''
            const max = data.maxValue
              ? _.round(data.maxValue * (data.maxValue > 0 ? 1.05 : 0.95), 2)
              : ''
            if (line) {
              if (isUpdate) {
                this.echartOption.yAxis[line.yAxisIndex].min = _.isNumber(min) ? min : null
                this.echartOption.yAxis[line.yAxisIndex].max = _.isNumber(max) ? max : null
                this.chartLine.setOption({
                  yAxis: this.echartOption.yAxis,
                })
              } else {
                o.minSection = o.minSection ? o.minSection : min
                o.maxSection = o.maxSection ? o.maxSection : max
                this.echartOption.yAxis[line.yAxisIndex].min = _.isNumber(o.minSection)
                  ? o.minSection
                  : null
                this.echartOption.yAxis[line.yAxisIndex].max = _.isNumber(o.maxSection)
                  ? o.maxSectio
                  : null
                this.chartLine.setOption({
                  yAxis: this.echartOption.yAxis,
                })
              }
            }
          }
        })
        this.getActualTable()
      }
    },
    // 计算interval
    computedInterval(date) {
      let interval = 1
      if (date === 0) {
        interval = 1
      } else if (date === 1) {
        interval = 80
      } else if (date === 2) {
        interval = 80 * 80
      } else if (date === 3) {
        interval = 80 * 80 * 24
      }
      return interval
    },
    // 计算时间跨度
    computedTimeSpan(span) {
      let time = null
      switch (span) {
        case 1:
          time = {
            value: 30,
            date: 'minutes',
          }
          break
        case 2:
          time = {
            value: 1,
            date: 'hours',
          }
          break
        case 3:
          time = {
            value: 4,
            date: 'hours',
          }
          break
        case 4:
          time = {
            value: 8,
            date: 'hours',
          }
          break
        case 5:
          time = {
            value: 1,
            date: 'days',
          }
          break
        case 6:
          time = {
            value: 7,
            date: 'days',
          }
          break
        default:
          time = {
            value: 10,
            date: 'minutes',
          }
          break
      }
      return time
    },
    // 勾选表格测点
    tableSelectChange(selected) {
      if (!this.trendDialog) return
      if (this.selected.length === 1 && selected.length === 0) {
        this.$message.warning('最少勾选一个测点!')
        this.$refs.trendTable.toggleRowSelection(this.selected[0])
        return
      }
      this.selected = selected
      this.switchChange(this.search.status)
    },
    // 保存y轴自定义
    saveYAxis(data) {
      const index = _.find(this.echartOption.series, { pointId: data.pointId }).yAxisIndex
      if (!this.echartOption.yAxis[index]) {
        return
      }
      if (data.maxSection !== '' && data.minSection !== '') {
        this.echartOption.yAxis[index].max = Number(data.maxSection)
        this.echartOption.yAxis[index].min = Number(data.minSection)
      } else if (data.maxSection !== '' && data.minSection === '') {
        this.echartOption.yAxis[index].max = Number(data.maxSection)
        delete this.echartOption.yAxis[index].min
      } else if (data.minSection !== '' && data.maxSection === '') {
        this.echartOption.yAxis[index].min = Number(data.minSection)
        delete this.echartOption.yAxis[index].max
      } else {
        delete this.echartOption.yAxis[index].min
        delete this.echartOption.yAxis[index].max
      }
      this.chartLine.setOption({
        yAxis: this.echartOption.yAxis,
      })
      // this.chartKey += 1
    },
    // 更新曲线数据
    async updateLine() {
      if (!this.condition.tagsId) {
        this.chartTimer = false
        return
      }
      this.condition.startTime = moment(this.condition.endTime)
        .add(1, 'seconds')
        .format('YYYY-MM-DD HH:mm:ss')
      this.condition.endTime = moment(this.condition.endTime)
        .add(1, 'seconds')
        .format('YYYY-MM-DD HH:mm:ss')
      const newData = await this.getTrendLine(this.condition)
      _.forEach(newData, (o) => {
        if (o.pointValues.length) {
          const data = [o.pointValues[0].timeValue * 1000, o.pointValues[0].value]
          const idx = _.findIndex(this.echartOption.series, { pointId: o.pointId })
          const seriesData = this.echartOption.series[idx].data
          if (
            idx > -1 &&
            (seriesData.length === 0 ||
              o.pointValues[0].timeValue * 1000 > seriesData[seriesData.length - 1][0])
          ) {
            this.echartOption.series[idx].data.shift()
            this.echartOption.series[idx].data.push(data)
            this.setXAxisInterval()
          }
        }
      })
      this.chartLine.setOption({
        series: this.echartOption.series,
        xAxis: this.echartOption.xAxis,
      })
      this.getActualData()
    },
    // 每秒获取实时数据并更新
    getActualData: _debounce(async function i() {
      if (!this.chartTimer) return
      await this.updateLine()
    }, 1000),
    getActualTable: _debounce(async function i() {
      if (!this.tableTimer || !this.isRealStatus) return
      const minArr = []
      const maxArr = []
      _.forEach(this.echartOption.series, (o) => {
        if (o.data.length) {
          minArr.push(o.data[0][0])
          maxArr.push(o.data[o.data.length - 1][0])
        }
      })
      this.tableCondition.startTime = moment(_.min(minArr)).format('YYYY-MM-DD HH:mm:ss')
      this.tableCondition.endTime = moment(_.max(maxArr)).format('YYYY-MM-DD HH:mm:ss')
      await this.getTableData(this.tableCondition, true)
    }, 1000),
  },
  created() {
    this.echartOption.tooltip.axisPointer.label.formatter = this.formatterFuns()
    this.echartOption.xAxis.axisLabel.formatter = this.formatterXAxis()
  },
  mounted() {},
  beforeDestroy() {
    this.chartTimer = false
    this.tableTimer = false
  },
}
</script>
<style scoped lang="scss">

.trend_dialog {
  /deep/ .el-dialog__body {
    height: 564px;
    padding: 10px 0;
  }
  /deep/ .el-dialog.is-fullscreen {
    margin-top: 0 !important;
    .el-dialog__body {
      height: calc(100% - 55px) !important;
    }
  }
}
.border_line {
  display: flex;
  align-items: center;
}
/deep/ .el-switch {
  .el-switch__label {
    position: absolute;
    display: none;
    color: #fff;
    &.is-active {
      display: block;
    }
    &,
    .el-switch__core {
      width: 50px !important;
    }
  }
  .el-switch__label--left {
    z-index: 9;
    left: 20px;
  }
  .el-switch__label--right {
    z-index: 9;
    left: -3px;
  }
}
.icon_hover {
  &:hover {
    color: #31b6f9;
  }
}
.color_box {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 10px;
  li {
    width: 20px;
    height: 20px;
    border: 5px solid transparent;
    box-sizing: content-box;
    &:hover {
      border-color: #1890ff;
    }
    &.active {
      border-color: #1890ff;
    }
  }
}
.trend_table {
  /deep/ .el-table th .el-checkbox {
    display: none;
  }
}
#lock-win {
  position: fixed;
  z-index: 3000;
  height: 200px;
  width: 300px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.5);
  text-align: left;
  text-indent: 10px;
  border: 1px solid #d9d9d9;
  left: 170px;
  bottom: 15px;
  h4 {
    font-size: 13px;
    color: #000;
    height: 38px;
    line-height: 38px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 0;
    background: rgba(245, 245, 245, 0.9);
    letter-spacing: 2px;
    font-weight: bold;
    cursor: pointer;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 5px;
      top: 8px;
      font-size: 14px;
      &:hover {
        color: #1890ff;
      }
    }
  }
  .tagId-list {
    height: 162px;
    overflow-y: auto;
    margin: 0;
    li {
      height: 32px;
      line-height: 32px;
      font-size: 12px;
      // background: rgba(0, 0, 0, 0.5);
      color: #000;
      border-bottom: 1px solid #d9d9d9;
      margin: 0;
      position: relative;
      cursor: pointer;
      .icon {
        cursor: pointer;
        position: absolute;
        right: 6px;
        top: 4px;
        font-size: 14px;
        &:hover {
          color: #1890ff;
        }
      }
    }
  }
}
// 媒体查询
@media screen and (max-width: 1366px) {
  .trend_dialog {
    /deep/ .el-dialog {
      margin-top: 4vh !important;
    }
  }
  #lock-win {
    height: 174px;
    width: 230px;
    h4 {
      height: 33px;
      line-height: 33px;
      .icon {
        top: 5px;
      }
    }
    .tagId-list {
      li {
        height: 28px;
        line-height: 28px;
        .icon {
          top: 2px;
        }
      }
    }
  }
}

@media screen and (max-width: 1680px) {
  #lock-win {
    height: 174px;
    width: 250px;
    h4 {
      height: 33px;
      line-height: 33px;
      .icon {
        top: 5px;
      }
    }
    .tagId-list {
      li {
        height: 28px;
        line-height: 28px;
        .icon {
          top: 2px;
        }
      }
    }
  }
}

</style>
